
import pageMeta from '~/mixins/pageMeta';
import Breadcrumbs from '~/components/elements/Breadcrumbs';
import BlogArticle from '~/components/elements/BlogArticle';
import CommentsList from '~/components/catalog/comments';

export default {
  name: 'BlogArticlePage',
  components: {
    BlogArticle,
    Breadcrumbs,
    CommentsList,
  },
  mixins: [pageMeta],
  async asyncData({$api, route, error, redirect}) {
    try {
      const { meta, article } = await $api.general.getPage(route.path)

      if (!meta || meta?.status > 400) {
        return error({ statusCode: meta?.status || 404 })
      }

      if (meta?.redirect) {
        return redirect(meta.status, meta.redirect)
      }

      const breadcrumbs = [
        {name: 'Главная', url: '/'},
        {name: 'Блог', url: '/blog'},
        {name: article.title, url: ''},
      ]

      return {
        pageTitle: meta?.title || '',
        pageMetaData: meta?.data || [],
        pageLinks: meta?.links || [],
        breadcrumbsList: breadcrumbs,
        article,
      }
    } catch (e) {
      return error({statusCode: 404})
    }
  },
  methods: {
    onReactionHandler({ id, status }) {
      const reaction = this.article?.reactions?.find(item => item.id === id)

      if (reaction) {
        reaction.count = status === 'add' ? reaction.count + 1 : reaction.count - 1
      }
    },
  },
}
